<template>
  <div v-if="preferencias">
    <div v-if="preferencias.body">
      <body-arkidian :preferencias="preferencias"></body-arkidian>
      <hair :preferencias="preferencias"></hair>
      <face :preferencias="preferencias"></face>
    </div>
    <img
      v-if="!preferencias.body && !preferencias.avatar"
      src="public/images/site/profile.svg"
      alt="Arkidia"
    />
    <img
      v-if="!preferencias.body && preferencias.avatar"
      :src="'public/'+ preferencias.avatar"
      alt="Arkidia"
    />
  </div>
</template>

<script>
import Face from "./Face";
import BodyArkidian from "./BodyArkidian";
import Hair from "./Hair";

export default {
  name: "app",
  components: {
    Face,
    BodyArkidian,
    Hair
  },
  data() {
    return {};
  },
  methods: {},
  props: ["preferencias"],

  mounted: function() {

  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/Arkidian.vue